// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__9O3sh"};